export const initialState = {  };

export function faqStatus(state = initialState, action = undefined) {
    switch(action.type) {
    case "FAQ_REQUEST":
        return {
          ...state,
          loading: true
        };
    case "FAQ_SUCCESS":
        return {
          ...state,
          loading: false,
          faq: action.faq,
        };
    case "FAQ_ERROR":
        return {
          ...state,
          error: action.error,
        };
    default:
        return {
            ...state
        }
    }
}